export default __webpack_public_path__ + "static/media/thumbnail_2.32ee51c0.webp";